import { Injectable, EventEmitter } from "@angular/core";
import {
  SignalRService,
  SignalREventService,
  ToastrService,
  PoweredByService,
  Equipment,
  MinesiteEquipment,
  EquipmentForModelAndPoweredBy,
  DataArray,
  Company,
  Document,
  User,
  GlobalService,
} from "./../index";

@Injectable()
export class EquipmentService {
  public equipmentChange: EventEmitter<Equipment[]> = new EventEmitter<
    Equipment[]
  >();
  public minesiteEquipmentChange: EventEmitter<MinesiteEquipment> =
    new EventEmitter<MinesiteEquipment>();
  public equipmentForPoweredByAndModelChange: EventEmitter<EquipmentForModelAndPoweredBy> =
    new EventEmitter<EquipmentForModelAndPoweredBy>();
  public showDetailsChange: EventEmitter<Equipment> =
    new EventEmitter<Equipment>();
  public manipulateEquipment: EventEmitter<Equipment> =
    new EventEmitter<Equipment>();
  public showRecommended: EventEmitter<Equipment> =
    new EventEmitter<Equipment>();
  public equipmentDocumentsChange: EventEmitter<Document[]> = new EventEmitter<
    Document[]
  >();
  public equipmentUsersChange: EventEmitter<User[]> = new EventEmitter<
    User[]
  >();
  public equipmentCompaniesChange: EventEmitter<Company[]> = new EventEmitter<
    Company[]
  >();
  public beginRecieve: EventEmitter<any> = new EventEmitter<any>();
  public baseLanguageChange: EventEmitter<Equipment> =
    new EventEmitter<Equipment>();

  public equipment: DataArray<Equipment> = new DataArray<Equipment>();

  private filterApplied = false;
  private serial = "";
  private active = true;
  private inactive = true;
  private live = true;
  private batch = 1;
  public setLive(flag: boolean): void {
    this.live = flag;
  }

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService,
    private _toastrService: ToastrService,
    private _poweredByService: PoweredByService,
    private _GlobalService: GlobalService
  ) {
    this.registerOnServerEvents();
  }
  public setFilter(serial: string, active: boolean, inactive: boolean): void {
    this.serial = serial;
    this.active = active;
    this.inactive = inactive;
    this.filterApplied = true;
  }
  public clearFilter(): void {
    this.serial = "";
    this.active = true;
    this.inactive = true;
    this.filterApplied = false;
  }
  public getEquipment(Live: boolean): void {
    this._signalRService.invoke("GetEquipment", Live);
  }
  public showDetails(equipment: Equipment): void {
    this.showDetailsChange.emit(equipment);
  }

  public removeAssociation(equipmentId: number) {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this._signalRService.invoke(
              "RemoveEquipmentAssociation",
              equipmentId,
              Number(localStorage.getItem("User_ID")),
              Number(localStorage.getItem("P_ID")),
              Number(6)
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this._signalRService.invoke(
              "RemoveEquipmentAssociation",
              equipmentId,
              Number(localStorage.getItem("User_ID")),
              Number(localStorage.getItem("P_ID")),
              Number(6)
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }
  public getUsersForEquipment(
    equipmentId: number,
    isStagedDetails: boolean
  ): void {
    this._signalRService.invoke(
      "GetUsersForEquipment",
      equipmentId,
      isStagedDetails
    );
  }
  public getDocumentsForEquipment(
    equipmentId: number,
    isStagedDetails: boolean
  ): void {
    this._signalRService.invoke(
      "GetDocumentsForEquipment",
      equipmentId,
      isStagedDetails
    );
  }
  public getCompaniesForEquipment(
    equipmentId: number,
    isStagedDetails: boolean
  ): void {
    this._signalRService.invoke(
      "GetCompaniesForEquipment",
      equipmentId,
      isStagedDetails
    );
  }

  public getEquipmentForMinesite(minesiteId: number): void {
    this.minesiteEquipment = new MinesiteEquipment();
    // this.batch = 1;
    this._signalRService.invoke("GetMinesiteEquipment", minesiteId, this.batch);
  }

  public getEquipmentForMinesiteStaging(minesiteId: number): void {
    this.minesiteEquipment = new MinesiteEquipment();
    this.batch = 1;
    this._signalRService.invoke(
      "getEquipmentForMinesiteStaging",
      minesiteId,
      this.batch
    );
  }

  public getEquipmentForModelAndPoweredBy(
    modelId: number,
    poweredById: number
  ): void {
    if (this.filterApplied) {
      this._signalRService.invoke(
        "FilterEquipment",
        modelId,
        poweredById,
        this.serial,
        this.active,
        this.inactive
      );
      return;
    }
    this._signalRService.invoke(
      "GetEquipmentForModelAndPoweredBy",
      modelId,
      poweredById
    );
  }
  public GetEquipmentForModelAndPoweredByStaging(
    modelId: number,
    poweredById: number
  ): void {
    if (this.filterApplied) {
      this._signalRService.invoke(
        "FilterEquipmentStaged",
        modelId,
        poweredById,
        this.serial,
        this.active,
        this.inactive
      );
      return;
    }
    this._signalRService.invoke(
      "GetEquipmentForModelAndPoweredByStaging",
      modelId,
      poweredById
    );
    //this._signalRService.invoke("GetPoweredBysStaged", modelId,Number(localStorage.getItem('P_ID')));
  }
  public manipulate(equipment: Equipment): void {
    this.manipulateEquipment.emit(equipment);
  }

  public create(equipment: Equipment): void {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this._signalRService.invoke(
              "CreateEquipment",
              equipment.Serial,
              equipment.ModelId,
              equipment.PoweredById,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this._signalRService.invoke(
              "CreateEquipment",
              equipment.Serial,
              equipment.ModelId,
              equipment.PoweredById,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }

  public save(equipment: Equipment): void {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this._signalRService.invoke(
              "UpdateEquipment",
              equipment.Equipment_ID,
              equipment.Serial,
              equipment.ModelId,
              equipment.PoweredById,
              equipment.Active,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this._signalRService.invoke(
              "UpdateEquipment",
              equipment.Equipment_ID,
              equipment.Serial,
              equipment.ModelId,
              equipment.PoweredById,
              equipment.Active,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }
  public delete(equipment: Equipment): void {
    this._signalRService
      .invoke("LockStagingTab", Number(localStorage.getItem("User_ID")))
      .then((result: any) => {
        if (result != null) {
          if (result.IsNew) {
            this._toastrService.displayToastrMessage(
              "success",
              "Staging environment is locked successfully",
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
            this._signalRService.invoke(
              "DeleteEquipment",
              equipment.Equipment_ID,
              equipment.Serial,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy == Number(localStorage.getItem("User_ID"))
          ) {
            this._signalRService.invoke(
              "DeleteEquipment",
              equipment.Equipment_ID,
              equipment.Serial,
              Number(localStorage.getItem("User_ID"))
            );
          } else if (
            result.IsLocked &&
            result.LockedBy != Number(localStorage.getItem("User_ID"))
          ) {
            this._toastrService.displayToastrMessage(
              "error",
              result.Note,
              "Staging environment Status!"
            );
            this._GlobalService.TriggerLockEnvironment("1");
          }
        }
      });
  }
  public updateBaseLanguage(equipmentId: number, baseLanguage: string): void {
    this._signalRService.invoke(
      "UpdateBaseLanguage",
      equipmentId,
      baseLanguage
    );
  }
  public showRecommendedDocuments(equipment: Equipment): void {
    this.showRecommended.emit(equipment);
  }
  private onEquipment(info: any): void {
    this.equipment.init();
    for (const item of info.Data.Equipment) {
      const equipment: Equipment = $.extend(new Equipment(), item);
      this.equipment.push(equipment);
    }

    this.equipmentChange.emit(this.equipment.Data);
  }

  private minesiteEquipment: MinesiteEquipment;

  private onEquipmentForMinesite(info: any): void {
    this.minesiteEquipment.BatchFinished = info.Data.BatchFinished;
    this.minesiteEquipment.Reload = info.Data.Reload;
    this.minesiteEquipment.IsLoading = info.Data.IsLoading;
    this.minesiteEquipment.Progress = info.Data.Progress;
    this.minesiteEquipment.MinesiteId = info.Data.MinesiteId;
    this.minesiteEquipment.Equipment = info.Data.Equipment;
    this.minesiteEquipmentChange.emit(this.minesiteEquipment);

    if (
      this.minesiteEquipment.IsLoading &&
      this.minesiteEquipment.BatchFinished
    ) {
      this.batch++;
      if (info.Data.IsLive) {
        this._signalRService.invoke(
          "GetMinesiteEquipment",
          this.minesiteEquipment.MinesiteId,
          this.batch
        );
      } else {
        this._signalRService.invoke(
          "getEquipmentForMinesiteStaging",
          this.minesiteEquipment.MinesiteId,
          this.batch
        );
      }
    }
    if (!this.minesiteEquipment.IsLoading) {
      this.minesiteEquipment = null;
    }
  }

  private onEquipmentForModelAndPoweredBy(info: any): void {
    const data: EquipmentForModelAndPoweredBy =
      new EquipmentForModelAndPoweredBy();
    const dataList: DataArray<Equipment> = new DataArray<Equipment>(1);

    for (const item of info.Data.Equipment) {
      dataList.update($.extend(new Equipment(), item), true);
    }

    data.ModelId = info.Data.ModelId;
    data.PoweredById = info.Data.PoweredById;
    data.Equipment = dataList.Data;

    //info.Data.isStaging
    this.equipmentForPoweredByAndModelChange.emit(data);
  }

  private onRemoveEquipmentAssociation(info: any): void {
    this.getEquipmentForMinesiteStaging(info.Data.Minesite.Minesite_ID);
    //this.GetEquipmentForModelAndPoweredByStaging(info.Data.Equipment.ModelId, info.Data.Equipment.PoweredById);

    //this._signalRService.invoke("Get_Minesite_Under_Project", Number(localStorage.getItem('P_ID')));
    //this._signalRService.invoke("Get_Company_Under_Project", Number(localStorage.getItem('P_ID')));
  }

  private onEquipmentDocuments(info: any): void {
    const documents: Document[] = [];
    for (const document of info.Data.Documents) {
      documents.push($.extend(new Document(), document));
    }
    this.equipmentDocumentsChange.emit(documents);
  }

  private onEquipmentUsers(info: any): void {
    const users: User[] = [];
    for (const user of info.Data.Users) {
      users.push($.extend(new User(), user));
    }
    this.equipmentUsersChange.emit(users);
  }

  private onEquipmentCompanies(info: any): void {
    const companies: Company[] = [];
    for (const copmany of info.Data.Companies) {
      companies.push($.extend(new Company(), copmany));
    }
    this.equipmentCompaniesChange.emit(companies);
  }

  private onEquipmentCreated(info: any): void {
    const equipment: Equipment = $.extend(new Equipment(), info.Data.Equipment);
    this.equipment.update(equipment, true);
    this._toastrService.displayToastrMessage(
      "success",
      "Equipment with serial number: " + equipment.Serial + " created!",
      "Equipment Create"
    );
    this.equipmentChange.emit(this.equipment.Data);
    //this._signalRService.invoke("GetEquipmentForModelAndPoweredByStaging", equipment.ModelId,equipment.PoweredById);
    //this.getEquipment(false);
    //this._signalRService.invoke("GetPoweredBysStaged", info.Data.Equipment.ModelId);
    //this.applyFilter("", true, true, false, [], [], []);
    //this._signalRService.invoke("FilterModels", "", true, true, false, [], [], []);
    //this.GetEquipmentForModelAndPoweredByStaging(info.Data.Equipment.ModelId, info.Data.Equipment.PoweredById);
    //this._signalRService.invoke("GetPoweredBysStaged", info.Data.Equipment.ModelId,Number(localStorage.getItem('P_ID')));
    //this._poweredByService.getPoweredBysByModelStaged(info.Data.Equipment.ModelId);
    //this._signalRService.invoke("Get_Models_Under_Project", Number(localStorage.getItem('P_ID')));
  }

  private onEquipmentUpdated(info: any): void {
    const equipment: Equipment = $.extend(new Equipment(), info.Data.Equipment);
    this.equipment.update(equipment, true);
    this.equipmentChange.emit(this.equipment.Data);
    this._toastrService.displayToastrMessage(
      "success",
      "Equipment with serial number: " + equipment.Serial + " updated!",
      "Equipment Update"
    );
    //this._poweredByService.getPoweredBysByModelStaged(info.Data.Equipment.ModelId);
    if (Number(localStorage.getItem("Lock")) === 0) {
      this._GlobalService.TriggerLockEnvironment("1");
    }
    //this._signalRService.invoke("Get_Models_Under_Project", Number(localStorage.getItem('P_ID')));
  }

  private onBaseLanguageUpdated(info: any): void {
    //let equipment: Equipment =  info;
    const equipment: Equipment = $.extend(new Equipment(), info.Data.Equipment);
    //let equipment: Equipment = $.extend(new Equipment(), info);
    this._toastrService.displayToastrMessage(
      "success",
      "Base Language: " + equipment.BaseLanguage + " updated!",
      "Base Lanaguage Update"
    );
    this.baseLanguageChange.emit(equipment);
  }

  private onEquipmentDeleted(info: any): void {
    const equipment: Equipment = $.extend(new Equipment(), info.Data.Equipment);
    this._toastrService.displayToastrMessage(
      "success",
      "Equipment with serial number: " + info.Data.Serial + " deleted!",
      "Equipment Delete"
    );
    //this.getEquipment(false);
    this._poweredByService.getPoweredBysByModelStaged(info.Data.ModelId);

    // refresh the minesite list
    this._signalRService.invoke("getMinesitesStaging");
  }

  private onBeginRecieve(info: any): void {
    this.beginRecieve.emit(info);
  }

  private registerOnServerEvents() {
    this._signalREventService.register(
      "EquipmentService",
      "equipment",
      (info: any) => this.onEquipment(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "removeEquipmentAssociation",
      (info: any) => this.onRemoveEquipmentAssociation(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "equipmentForMinesite",
      (info: any) => this.onEquipmentForMinesite(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "equipmentForModelAndPoweredBy",
      (info: any) => this.onEquipmentForModelAndPoweredBy(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "beginRecieveEquipmentForModelAndPoweredBy",
      (info: any) => {
        this.onBeginRecieve(info);
      }
    );
    this._signalREventService.register(
      "EquipmentService",
      "equipmentDocuments",
      (info: any) => this.onEquipmentDocuments(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "equipmentUsers",
      (info: any) => this.onEquipmentUsers(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "equipmentCompanies",
      (info: any) => this.onEquipmentCompanies(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "equipmentCreated",
      (info: any) => this.onEquipmentCreated(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "equipmentUpdated",
      (info: any) => this.onEquipmentUpdated(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "equipmentDeleted",
      (info: any) => this.onEquipmentDeleted(info)
    );
    this._signalREventService.register(
      "EquipmentService",
      "baseLanguageUpdated",
      (info: any) => this.onBaseLanguageUpdated(info)
    );
  }

  public deregisterOnServerEvents(): void {
    this._signalREventService.deregister("EquipmentService");
  }
}
